
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskflowTemplateModel } from './Entities.GormCrm.TaskflowTemplate';
import { Model, ModelProperty } from 'models/Model';


export class TaskflowTemplateTagModel extends Model<TaskflowTemplateTagModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'tag', type: 'string' },
		{ name: 'taskflowTemplateId', type: 'string' },
		{ name: 'taskflowTemplate', type: 'TaskflowTemplateModel', isHidden: true, isObject: true, new: () => { return new TaskflowTemplateModel }, properties: () => { return TaskflowTemplateModel.classProperties } }
	];
	[key: string]: any;
	
	public tag: string;
	public taskflowTemplateId?: string;
	public taskflowTemplate?: TaskflowTemplateModel;
    
	constructor(){
		super();
		this.tag = '';
		this.taskflowTemplateId = undefined;
		this.taskflowTemplate = undefined;
		
	}
	getProperties(){
		return TaskflowTemplateTagModel.classProperties;
	}
}

